export default [
  {
    label: "United States",
    value: "united-states",
    iso_country_code: "us"
  },
  {
    label: "Europe",
    value: "Europe",
    iso_country_code: "eu"
  },
  {
    label: "Canada",
    value: "canada",
    iso_country_code: "ca"
  },
  {
    label: "United Kingdom",
    value: "united-kingdom",
    iso_country_code: "gb"
  },
  {
    label: "Australia",
    value: "australia",
    iso_country_code: "au"
  },
  {
    label: "Bulgaria",
    value: "bulgaria",
    iso_country_code: "bg"
  },
  {
    label: "China",
    value: "china",
    iso_country_code: "cn"
  },
  {
    label: "Estonia",
    value: "estonia",
    iso_country_code: "ee"
  },
  {
    label: "France",
    value: "france",
    iso_country_code: "fr"
  },
  {
    label: "Germany",
    value: "germany",
    iso_country_code: "de"
  },
  {
    label: "Greece",
    value: "greece",
    iso_country_code: "gr"
  },
  {
    label: "Hong Kong",
    value: "hong-kong",
    iso_country_code: "hk"
  },
  {
    label: "Italy",
    value: "italy",
    iso_country_code: "it"
  },
  {
    label: "Pakistan",
    value: "pakistan",
    iso_country_code: "pk"
  },
  {
    label: "Russia",
    value: "russia",
    iso_country_code: "ru"
  },
  {
    label: "Singapore",
    value: "singapore",
    iso_country_code: "sg"
  },
  {
    label: "Spain",
    value: "spain",
    iso_country_code: "es"
  },
  {
    label: "Sweden",
    value: "sweden",
    iso_country_code: "se"
  },
  {
    label: "Turkey",
    value: "turkey",
    iso_country_code: "tr"
  },
  {
    label: "Ukraine",
    value: "ukraine",
    iso_country_code: "ua"
  },
  {
    label: "Netherlands",
    value: "netherlands",
    iso_country_code: "nl"
  },
  {
    label: "Ireland",
    value: "ireland",
    iso_country_code: "ie"
  },
  {
    label: "India",
    value: "india",
    iso_country_code: "in"
  }
];



// WEBPACK FOOTER //
// ./src/newDropshipperApp/utils/staticData/shipsFromCountries.js